import React from 'react';
import { useAuth } from '../../../../_mApp/auth';
import { transform } from '../../../../app/helpers/transform';
import { MenuInnerWithSub } from './MenuInnerWithSub';
import { MenuItem } from './MenuItem';
import { WEBSITE_NAV_V2 } from '../../../../app/consts/nav';
import { WEBSITE_NAV } from './nav';

export function MenuInner({ text_color }) {
    const { currentUser } = useAuth();
    const nav =
        currentUser?.user_type === 'borrower'
            ? WEBSITE_NAV(currentUser, currentUser?.user_type)
            : WEBSITE_NAV_V2(currentUser);
    return (
        <>
            {nav?.map((item, index) => {
                return (
                    <React.Fragment key={`item_${index}`}>
                        {item.enabled === true && (
                            <>
                                {item.children && (
                                    <MenuInnerWithSub
                                        to={item.url || ''}
                                        title={item.label || ''}
                                        icon={transform('icon', item.icon)}
                                        hasArrow={true}
                                        menuPlacement='bottom-start'
                                        menuTrigger={`{default:'click', lg: 'hover'}`}>
                                        {item?.children?.map((subitem, subIndex) => {
                                            return (
                                                <React.Fragment
                                                    key={`item_${index}_subitem_${subIndex}`}>
                                                    {subitem.enabled === true && (
                                                        <>
                                                            {subitem.type === 'content' ? (
                                                                <div className='menu-item'>
                                                                    <div className='menu-content'>
                                                                        <div className='menu-section text-muted ms-10'>
                                                                            {subitem.label}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <MenuItem
                                                                    text_color={text_color}
                                                                    disabled={subitem.disabled}
                                                                    to={subitem.url}
                                                                    title={subitem.label}
                                                                    icon={subitem.icon}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </MenuInnerWithSub>
                                )}
                                {!item.children && (
                                    <MenuItem
                                        text_color={text_color}
                                        icon={item.icon}
                                        disabled={item.disabled}
                                        to={item.url || ''}
                                        title={item.label}
                                    />
                                )}
                            </>
                        )}
                    </React.Fragment>
                );
            })}
        </>
    );
}
